import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Progress } from "@/components/ui/progress";

export default function MyCourses() {
  const { user } = useAuth();
  const isStudent = user?.role === "student";
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      if (isStudent) {
        const { data } = await api.get("/enrollments/me");
        setItems(data);
      } else {
        const { data } = await api.get("/courses");
        setItems(data);
      }
    } finally { setLoading(false); }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, []);

  const bump = async (courseId, progress) => {
    const np = Math.min(100, progress + 25);
    await api.post("/enrollments/progress", { course_id: courseId, progress: np });
    toast.success(np >= 100 ? "Course completed! 恭喜!" : "Progress updated");
    load();
  };

  if (loading) return <p className="font-mono text-clay text-sm">加载中…</p>;

  return (
    <div>
      <h1 className="font-serif text-4xl tracking-tight mb-2">{isStudent ? "My Courses" : "Course Catalog"}</h1>
      <p className="text-clay mb-8">{isStudent ? "Track your learning progress." : "All programs offered by CCLPT."}</p>

      {isStudent && items.length === 0 ? (
        <div className="border border-black/10 bg-white p-12 text-center">
          <p className="text-clay">You're not enrolled in any course yet.</p>
          <Link to="/courses" className="inline-block mt-4 px-6 py-3 bg-ink text-rice hover:bg-cinnabar transition-colors">Browse Courses</Link>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((it) => {
            const c = isStudent ? it.course : it;
            if (!c) return null;
            return (
              <div key={c.course_id} className="border border-black/10 bg-white" data-testid={`mycourse-${c.slug}`}>
                <img src={c.image} alt={c.title} className="w-full h-36 object-cover border-b border-black/10" />
                <div className="p-5">
                  <p className="label text-gold">{c.level} · {c.hsk}</p>
                  <h3 className="font-display font-bold text-lg mt-2">{c.title}</h3>
                  {isStudent ? (
                    <div className="mt-4">
                      <div className="flex justify-between text-xs text-clay mb-1"><span>Progress</span><span>{it.progress}%</span></div>
                      <Progress value={it.progress} className="h-2" />
                      {it.progress < 100 && (
                        <button onClick={() => bump(c.course_id, it.progress)} data-testid={`progress-${c.slug}`}
                          className="w-full mt-4 py-2.5 text-sm bg-ink text-rice hover:bg-cinnabar transition-colors">Mark next module done</button>
                      )}
                      {it.progress >= 100 && <p className="mt-4 text-sm text-cinnabar font-medium">✓ Completed</p>}
                    </div>
                  ) : (
                    <p className="text-sm text-clay mt-2">{c.tagline}</p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
